import Modal from '@ui/modal/modal';
import Button from '@ui/buttons/button/button';
import Text from '@ui/text/text/text';
import Container from '@ui/container/container';
import { TButtonAndLinkDesigns } from '@styles/design-system/local-components/local-components.types';
import getThemeColorsCssMixVariable from '@/utils/colors/get-theme-color-css-mix-variable';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';
import { EColorVariablesV2 } from '@/types/theme-packs.types';
import getThemeColorContrastCSSVariable from '@/utils/colors/get-theme-color-contrast-css-variable';

type AudienceConfirmRemoveProps = {
  open: boolean;
  count?: number;
  onClose: () => void;
  onConfirm: () => void;
};

const AudienceConfirmRemove = ({ open, count = 1, onClose, onConfirm }: AudienceConfirmRemoveProps) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal
      open={open}
      onRequestClose={onClose}
      focusLockProps={{ autoFocus: false }}
      customSize={{
        height: '192px',
        width: '480px',
        maxWidth: 'calc(100% - 32px)',
      }}
      contentWrapperClassName="padding-h-40 padding-v-24 flex-1 flex-column"
      backgroundColor="var(--gray-900)"
      RenderHeaderContent={() => (
        <Container className="flex ai-center gap-12">
          <Text className="H4" design="GlobalIcoText1">
            {' '}
            Do you want to remove {count === 1 ? 'the list' : 'these lists'}?
          </Text>
        </Container>
      )}
      RenderFooterContent={() => (
        <Container background="var(--gray-900)" className="flex fd-row jc-flex-end gap-16 margin-t-24">
          <Button
            onClick={onClose}
            design={TButtonAndLinkDesigns.LocalBttnSec}
            className="L1 padding-v-16 padding-h-24"
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            backgroundColor={getThemeColorCSSVariable()}
            hoverBackgroundColor={getThemeColorsCssMixVariable()}
            color={getThemeColorContrastCSSVariable(EColorVariablesV2.buttonText, EColorVariablesV2.primary)}
            className="L1 padding-v-16 padding-h-24"
          >
            Confirm
          </Button>
        </Container>
      )}
    >
      <Text className="P1" design="GlobalIcoText3">
        {count === 1 ? 'It' : 'They'} will still be available on a channel level
      </Text>
    </Modal>
  );
};

export default AudienceConfirmRemove;
